'use client'

import React, { useEffect, useRef, useState } from 'react'
import { AYAdSlot } from '@/components/frontend/AYAdSlot'

export const StickyScrollAd: React.FC = () => {
    const stickyRef = useRef<HTMLDivElement>(null)
    const [isFixed, setIsFixed] = useState(false)
    const [hasTriggered, setHasTriggered] = useState(false)
    const timeoutRef = useRef<NodeJS.Timeout | null>(null)

    useEffect(() => {
        const handleScroll = () => {
            if (!stickyRef.current || isFixed || hasTriggered) return

            const offsetTop = stickyRef.current.offsetTop
            if (window.scrollY > offsetTop + 1) {
                setIsFixed(true)
                setHasTriggered(true)

                setTimeout(() => {
                    setIsFixed(false)
                    window.removeEventListener('scroll', handleScroll)
                }, 3000)
            } else {
                setIsFixed(false)
            }
        }

        window.addEventListener('scroll', handleScroll)

        // Disable scroll handler after 5 seconds
        timeoutRef.current = setTimeout(() => {
            window.removeEventListener('scroll', handleScroll)
        }, 5000)
    }, [isFixed, hasTriggered])

    return (
        <div ref={stickyRef} className='hidden md:block h-[315px]'>
            <div className='relative'>
                <div className={`left-0 right-0 top-0 transition-all duration-300 ${isFixed ? 'fixed z-50' : 'absolute'}`}>
                    <div className='hidden lg:block py-8 border-b bg-[hsl(0_0%_97.6%)]'>
                        <AYAdSlot adId='qz.com_970x250' width={970} height={250} />
                    </div>
                    <div className='lg:hidden py-8 border-b bg-[hsl(0_0%_97.6%)]'>
                        <AYAdSlot adId='qz.com_336x280' width={336} height={280} />
                    </div>
                </div>
            </div>
        </div>
    )
}
